import DefaultArrayTemplateComponent from '../fieldsets/Array/DefaultArrayTemplate.component';
import TextModeArrayTemplate from '../fieldsets/Array/displayMode/TextModeArrayTemplate.component';

const widgets = {
	array: DefaultArrayTemplateComponent,
	array_text: TextModeArrayTemplate,
};

export default widgets;
